// Shared S3 asset URL helpers for the data-driven Living Well Center manifests.
//
// 2026 assets live under pdf/2026/. Filenames contain spaces & specials, so we
// encodeURIComponent each path segment (space->%20, &->%26, ,->%2C; parens left
// as-is, matching the actual S3 keys). Legacy (pre-2026) assets are passed as
// full URLs verbatim because their keys already use `+` for spaces.

export const S3 = "https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com";

const enc = (s) => encodeURIComponent(s);

// 2026 resource PDF inside a category folder under "LWC 6.4 files to download".
export const pdf2026 = (category, file) =>
  `${S3}/pdf/2026/${enc("LWC 6.4 files to download")}/${enc(category)}/${enc(file)}`;

// 2026 thumbnail JPG in the shared jpgs/ folder.
export const thumb2026 = (file) => `${S3}/pdf/2026/jpgs/${enc(file)}`;

// 2026 website logo in jpgs/weblink graphics/.
export const weblink = (file) => `${S3}/pdf/2026/jpgs/${enc("weblink graphics")}/${enc(file)}`;
